import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PortalShell } from '@/shared/patterns/AppShell';
import { creditNav, CREDIT_PORTAL_TITLE } from '@/domains/credit';
import { requirePortal } from '@/app/entry/portalGuards';

export const Route = createFileRoute('/_backoffice/credit')({
    beforeLoad: ({ context }) => requirePortal(context.auth, 'credit'),
    component: () => (
        <PortalShell title={CREDIT_PORTAL_TITLE} nav={creditNav}>
            <Outlet />
        </PortalShell>
    ),
});
